export default "__VITE_ASSET__B0D9xotT__"